import { render, staticRenderFns } from "./AppFileField.vue?vue&type=template&id=5aa4aded&"
import script from "./AppFileField.vue?vue&type=script&lang=js&"
export * from "./AppFileField.vue?vue&type=script&lang=js&"
import style0 from "./AppFileField.vue?vue&type=style&index=0&id=5aa4aded&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports